import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addToAnalogIcon from "./../../img/icons/addToAnalogIcon.svg";
import addedToAnalogIcon from "./../../img/icons/addedToMyAnalog.svg";
import PartsAddToAnalogIcon from './../../img/icons/parts_add_to_My_analog.svg';
import { setModalState, closeModal, getProjects, openModal } from "../../actions/myanalog";
import { LoadingIcon } from "../LoadingIcon.js/LoadingIcon";
import ToolTip from "../ToolTip";
import { getAccount, getAuthToken } from "../../constants/config/authentication";
import { APP_LANGUAGE } from "../../constants";
import english from "../../constants/labels/english";

const { opensModal } = english;

export const AddMyAnalogModalIcon = (props) => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.myanalog);
  const addedToMyAnalogState = useSelector((state) => state.myanalog);
  let productIDIsPresent = false;
  const labels = useSelector( state => state.labels );
  const { button: buttonLabels } = labels;
  const {
    addedToMyAnalog: addedToMyAnalogLabel,
    addToMyAnalog: addToMyAnalogLabel,
    confirm: confirmLabel,
  } = buttonLabels;

  const {
    addToMyAnalogModalDescTable,
    addToMyAnalogModalDesc,
    addToMyAnalogDropdownTitleTable,
    addToMyAnalogDropdownTitle,
    myAnalogProjectTable,
    myAnalogProjectProduct,
  } = labels;

  addedToMyAnalogState.productsSuccessState.forEach((e) => {
    if (e === props.productID) {
      productIDIsPresent = true;
    }
  });

  const successState = props.productID
    ? productIDIsPresent
    : addedToMyAnalogState.tableSuccessState;

  const key = props.productID ? props.productID : props.tableName;
  const imageSrc = (
    successState
      ? addedToAnalogIcon
      : (
          props.className
            ? addToAnalogIcon
            : (
                props.partsData
                  ? PartsAddToAnalogIcon
                  : addToAnalogIcon
            )
      )
  );

  /**
   * Closes the modal when the user confirms adding to My Analog.
   */
  const confirmAddToMyAnalog = () => {
    dispatch(closeModal());
  };

  /**
   * Displays a modal to add a product to My Analog if the user is authenticated.
   * If the user is not authenticated, it initiates the login process.
   */
  const addToMyAnalogModal = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    if (token) {
      dispatch(
        setModalState({
          modalTitle: addToMyAnalogLabel,
          modalMessage: props.tableName ? addToMyAnalogModalDescTable : addToMyAnalogModalDesc,
          modalConfirmMessage: confirmLabel,
          haveActions: true,
          haveDropDown: true,
          haveFilter: false,
          onConfirm: confirmAddToMyAnalog,
          onCancel: () => dispatch(closeModal()),
          dropDownTitle: props.tableName ? addToMyAnalogDropdownTitleTable : addToMyAnalogDropdownTitle,
          dropDownDefaultText: props.tableName ? myAnalogProjectTable : myAnalogProjectProduct,
          tableModal: props.tableName,
          productID: props.productID,
          productURL: window.location.href,
          productsURL: `${new URL(window.location.href).origin}/${APP_LANGUAGE}/products`
        })
      );
      dispatch( openModal() );
    } else {
      getAccount()?.login?.();
    }
  };

  /**
  * Handles the key press event, triggering an action if Enter key is pressed.
  *
  * @param {KeyboardEvent} event - The key press event.
  */
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      addToMyAnalogModal(event);
    }
  };

  return (
    <span className="parts__tooltip-wrapper">
      <ToolTip label={successState ? addedToMyAnalogLabel : addToMyAnalogLabel} />
      <img
        width={props.mobile ? "24" : "16"}
        height={props.mobile ? "24" : "16"}
        key={key}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        role="button"
        aria-label={`${addToMyAnalogLabel}. ${opensModal}`}
        className={props.className ?? "add-my-analog-btn"}
        src={imageSrc}
        onClick={addToMyAnalogModal}
        alt={successState ? addedToMyAnalogLabel : addToMyAnalogLabel}
      />
    </span>
  );
};